<template>
  <div id="add-group-modal">
    <form action="#" v-on:submit.prevent="submitForm">
      <alert-dynamic-component
        :key="notif_key"
        v-if="show_notif"
        :type="notif.type"
        :title="notif.title"
        :subtitle="notif.subtitle"
      />
      <div class="form-group">
        <label for="inputGroup">Grup <span class="text-danger">*</span></label>
        <input
          type="text"
          id="inputGroup"
          name="group"
          v-model="group"
          class="form-control"
          placeholder="Masukkan Nama Grup"
          required
        />
      </div>
      <div class="form-group" align="right">
        <button
          class="btn btn-danger m-r-5"
          data-dismiss="modal"
          aria-hidden="true"
          type="button"
        >
          Batal
        </button>
        <button class="btn btn-warning" type="submit">Simpan</button>
      </div>
    </form>
    <floating-loader-component v-if="is_loading" text="Menyimpan Data ..." />
  </div>
</template>

<script>
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import floating_loader from "@/views/components/floating_loader.vue";

export default {
  name: "modal_add_group",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "alert-dynamic-component": alert_dynamic,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      is_edit:
        this.data.length > 0 ? ("group" in this.data[0] ? true : false) : false,
      group:
        this.data.length > 0
          ? "group" in this.data[0]
            ? this.data[0].group
            : null
          : null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      api: process.env.VUE_APP_API_URL,
      callback: this.data.length > 0 ? this.data[0].callback : null,
      notif_key: 0,
      notif: null,
      show_notif: false,
      is_loading: false,
    };
  },
  methods: {
    submitForm: function () {
      if (this.group) {
        let api;
        let data;
        if (this.is_edit) {
          api = this.api + "new-group-update";
          data = {
            _id: this.$sanitize(this.data[0].id),
            group: this.$sanitize(this.group),
          };
        } else {
          api = this.api + "new-group-add";
          data = {
            id_project: this.id_project,
            group: this.$sanitize(this.group),
          };
        }

        this.is_loading = true;
        this.$http
          .post(api, data)
          .then((response) => {
            if (response.status == 200) {
              if (this.callback) {
                this.callback();
              }
              if (response.data.status == "Already Exist") {
                this.notif = {
                  type: "danger",
                  title: "Error!",
                  subtitle: "Nama grup telah tersedia.",
                };
                this.show_notif = true;
                this.notif_key++;
                this.group = null;
              } else {
                this.notif = {
                  type: "success",
                  title: "Berhasil!",
                  subtitle: "Grup berhasil disimpan.",
                };
                this.show_notif = true;
                this.notif_key++;
                this.group = null;
              }
            } else {
              this.notif = {
                type: "danger",
                title: "Error!",
                subtitle: "Nama grup telah tersedia",
              };
              this.show_notif = true;
              this.notif_key++;
            }
          })
          .catch((err) => {
            this.notif = {
              type: "danger",
              title: "Error!",
              subtitle: `${
                err.response
                  ? err.response.data.status
                  : "Nama grup telah tersedia"
              }`,
            };
            this.show_notif = true;
            this.notif_key++;
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
  },
};
</script>
